import { useMedia } from "use-media";

export const MOBILE_MAX = 812;

export const useResponsive = () => {
  return { isMobile: useMedia({ maxWidth: MOBILE_MAX }) };
};
